import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentIdPayload } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: DocumentIdPayload) =>
    $actions.document.addTemplateToApi(dispatch, payload),
  );
};
